// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerShipToAddressStyles } from "@sc/Overrides/Widgets/Common/HeaderShipToAddress";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

headerShipToAddressStyles.titleIcon = {
    size: 14,
    color: "common.ui1",
    css: css`
        margin-left: 8px;
        opacity: 0.66;
        ${xScreen("lte", "md")} {
            color: ${color("text.link")};
            opacity: 1;
        }
    `,
};

headerShipToAddressStyles.titleTypography = {
    size: 14,
    lineHeight: "22px",
    weight: "bold",
    css: css`
        color: ${color("common.ui1")};
        ${xScreen("lte", "md")} {
            color: ${color("text.main")};
            font-weight: normal;
        }
    `,
};
headerShipToAddressStyles.titleLabelTypography = {
    size: 14,
    lineHeight: "22px",
    css: css`
        color: ${color("common.ui1")};
        ${xScreen("lte", "md")} {
            color: ${color("text.main")};
            width: 100%;
            font-weight: bold;
        }
    `,
    ellipsis: true,
};

headerShipToAddressStyles.shipToAddressWrapper = {
    css: css`
        display: inline-flex;
        width: auto;
    `,
};
headerShipToAddressStyles.titleClickable = {
    css: css`
        padding: 0;
        display: flex;
        column-gap: 4px;
        align-items: center;
        ${xScreen("lte", "md")} {
            flex-wrap: wrap;
            row-gap: 8px;
        }
    `,
};
headerShipToAddressStyles.titleWrapper = {
    css: css`
        display: flex;
        column-gap: 4px;
        align-items: center;
        flex-wrap: wrap;
        row-gap: 8px;
    `,
};
headerShipToAddressStyles.drawer = {
    cssOverrides: {
        drawerContent: css`
            height: 100%;
            margin: 0 30px 15px;
            overflow-y: inherit;
        `,
        drawerBody: css`
            height: auto;
            max-height: 500px;
            overflow-x: inherit;
            overflow-y: inherit;
        `,
    },
};
headerShipToAddressStyles.drawerInShell = {
    cssOverrides: {
        drawerContent: css`
            height: 100%;
            margin: 0 30px 15px;
            overflow-y: inherit;
        `,
        drawerBody: css`
            height: auto;
            overflow-x: inherit;
            overflow-y: inherit;
        `,
    },
};
